var Constants = (function (backOffice, $) {
    backOffice.Constants = (function () {
        return {
            ReportExportJobType: "ReportExport",
            CustomerExportJobType: "CustomerExport",
            ProductMasterExportJobType: "ProductMasterExport",
            ExportPendingStatus: "Pending",
            ExportInProgressStatus: "DownloadInProgress",
            ReportExportTypes: {
                ItemDetailExportReport: "ItemDetailExportReport",
                SalesDetailExport: "SalesDetailExport",
                FulfilledSalesReportExport: "FulfilledSalesReportExport",
                SalesReportExport: "SalesReport",
                InventoryValuationReportExport: "InventoryValuationReportExport",
                EOMInventoryValuationReportExport: "EOMInventoryValuationReportExport",
                FinancialMovementLogReportExport: "FinancialMovementLogReportExport",
                IncomeReportExport: "IncomeReportExport",
                ProductSalesReportExport: "ProductSalesReportExport",
                LaybyMovementReportExport: "LaybyMovementReportExport",
                StylePerformanceReportExport: "StylePerformanceReportExport",
                PODetailReportExport: "PODetailReportExport",
                TransferDetailReportExport:"TransferDetailReportExport",
                EndOfDayReportExport: "EndOfDayReportExport",
                InventoryPlanningReportExport: "InventoryPlanningReportExport",
                StockSalesMatrixByColourReportExport: "StockSalesMatrixByColourReportExport",
                StockListReportExport: "StockListReportExport",
                POStockReceiptDetailsReportExport: "POStockReceiptDetailsReportExport",
                ReturnReasonReportExport: "ReturnReasonReportExport",
                ReturnReasonReportLimitedExport: "ReturnReasonReportLimitedExport",
                ProductSearchManagementExport: "ProductSearchManagementExport",
                StockSalesMatrixByColourReportExport: "StockSalesMatrixByColourReportExport",
                ProductDetailLogReportExport: "ProductDetailLogReportExport",
                GrossProfitReportInvoicedExport: "GrossProfitReportInvoicedExport",
                GrossProfitReportFulfilledExport: "GrossProfitReportFulfilledExport",
                ItemSalesReportExport: "ItemSalesReportExport",
                SalesPerformanceSummaryExport: "SalesPerformanceSummaryExport",
                ProductSearchExport: "ProductSearchExport"
            },
            ReportExportFormats: {
                CSV: 'CSV',
                EXCEL: 'XLSX',
            },
            SystemSettingNames: {
                CustomerServiceEmail: 'CustomerServiceEmail',
            },
            DefaultSystemEmail: "noreply@retailexpress.com.au",
            SystemProductAttributes: {
                Brand: 1,
                Season: 2,
                Size: 3,
                Colour: 4
            }
        };
    })();
    return backOffice.Constants;
})(BackOffice || {}, jQuery);